var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 0H0.95C0.698134 0.000308769 0.456669 0.105765 0.278573 0.293234C0.100477 0.480704 0.00029333 0.734878 0 1V17C0.00029333 17.2651 0.100477 17.5193 0.278573 17.7068C0.456669 17.8942 0.698134 17.9997 0.95 18H18.05C18.3019 17.9997 18.5433 17.8942 18.7214 17.7068C18.8995 17.5193 18.9997 17.2651 19 17V1C18.9997 0.734878 18.8995 0.480704 18.7214 0.293234C18.5433 0.105765 18.3019 0.000308769 18.05 0ZM1.26667 1.33333H5.06667V4.33333H1.26667V1.33333ZM17.7333 16.6667H1.26667V5.66667H17.7333V16.6667ZM17.7333 4.33333H6.33333V1.33333H17.7333V4.33333Z",
    fill: "#001C35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.9c31feb1.svg";
export { ForwardRef as ReactComponent };